import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Sidebar, ToastContent } from "../../../shared/components";
import { PermissionActionsEnum, PermissionRolesEnum } from "../../../shared/enums/profiles";
import { AuthGuard } from "../../../shared/guards/AuthGuard";
import { checkByProfileGuard } from "../../../shared/guards/ProfileGuard";
import { useToast } from "../../../shared/hooks";
import QuotationPage from "../Quotation/components/QuotationPresentation";

export const FireQuotePage = (): JSX.Element => {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const toast = useToast();
	const id = searchParams.get("id");

	const canAdd = checkByProfileGuard(
		PermissionRolesEnum.FireOptions,
		PermissionActionsEnum.Add
	);

	const canEdit = checkByProfileGuard(
		PermissionRolesEnum.FireOptions,
		PermissionActionsEnum.Update
	);

	useEffect(() => {
		// Modo Edição
		if (id && !canEdit) {
			toast.present({
				type: "error",
				position: "top-right",
				messageOrContent: <ToastContent title="Acesso Negado" content="Você não tem permissão para editar cotações." />,
			});
			navigate("/incendio");
			return;
		}

		// Modo Criação
		if (!id && !canAdd) {
			toast.present({
				type: "error",
				position: "top-right",
				messageOrContent: <ToastContent title="Acesso Negado" content="Você não tem permissão para criar cotações." />,
			});
			navigate("/incendio");
			return;
		}
	}, [id, canAdd, canEdit, navigate, toast]);

	// Se não tiver permissão, retorna null enquanto redireciona (evita flash de conteúdo)
	if ((id && !canEdit) || (!id && !canAdd)) {
		return <></>;
	}

	return (
		<AuthGuard>
			<Sidebar>
				<QuotationPage />
			</Sidebar>
		</AuthGuard>
	);
};
